import { DefaultFontFamily } from 'app/common/react/components/common/FontFamily';

const cssStyles = () => {
  let styles = '';

  const container = `
.OpenCategoriesMenuController__container {
  font-family: ${DefaultFontFamily};
}
`;

  const button = `
.OpenCategoriesMenuController__container .Button.openCategoriesHeader {
    -webkit-box-align: center !important;
    -webkit-align-items: center !important;
    -ms-flex-align: center !important;
    -ms-grid-row-align: center !important;
    align-items: center !important;
    background-color: #fff !important;
    background: -webkit-gradient(linear, left top, left bottom, from(#fff), to(#f0f0f0));
    background: -webkit-linear-gradient(#fff, #f0f0f0);
    background: linear-gradient(#fff, #f0f0f0);
    background-image: none !important;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    border: none !important;
    color: #5f5f5f;
    cursor: pointer;
    display: -webkit-box !important;
    display: -webkit-flex !important;
    display: -ms-flexbox !important;
    display: flex !important;
    outline: none;
    position: relative;
    text-decoration: none;
    font-weight: bold;
    text-shadow: 0 1px #fff;
    white-space: nowrap;
    height: 36px;
}
`;

  const buttonEmphasis = `
.OpenCategoriesMenuController__container .a {
    color: #717171;
    font-weight: bold;
    text-decoration: none;
}
`;

  const buttonSpan = `
.OpenCategoriesMenuController__container .Button .accessibilityText {
    font: 0 / 0 serif;
    text-shadow: none;
    color: transparent;
    position: absolute;
}
`;

  const dropdown = `
.OpenCategoriesMenuController__container .positionModuleElement.defaultCaret.positionBottom {
    margin-top: 11px;
}
.OpenCategoriesMenuController__container .Dropdown.positionModuleElement.active {
    min-height: 0;
}
.OpenCategoriesMenuController__container .positionModuleElement.positionModuleFixed {
    position: fixed;
    z-index: 686;
}
.OpenCategoriesMenuController__container .positionModuleElement.active {
    display: block;
    min-height: 50px;
    min-width: 50px;
}
.OpenCategoriesMenuController__container .Module.slideIn {
    -webkit-animation: menu-slide-in-up 0.3s;
    animation: menu-slide-in-up 0.3s;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
}
.OpenCategoriesMenuController__container .positionModuleElement {
    -webkit-box-shadow: 0 1px 5px 0 rgba(0,0,0,0.25);
    box-shadow: 0 1px 5px 0 rgba(0,0,0,0.25);
    -webkit-transform: translateZ(0);
    background: #fff;
    border-radius: 6px;
    display: none;
    position: absolute;
    z-index: 685;
}
.OpenCategoriesMenuController__container .Dropdown {
    text-align: left;
}
@-webkit-keyframes menu-slide-in-up {
    from {
        opacity: 0;
        -webkit-transform: translateY(30px);
        transform: translateY(30px)
    }

    to {
        opacity: 1;
        -webkit-transform: translateY(0);
        transform: translateY(0)
    }
}

@keyframes menu-slide-in-up {
    from {
        opacity: 0;
        -webkit-transform: translateY(30px);
        transform: translateY(30px)
    }

    to {
        opacity: 1;
        -webkit-transform: translateY(0);
        transform: translateY(0)
    }

}
`;

  const categoriesMenu = `
.OpenCategoriesMenuController__container .CategoriesMenu {
    -webkit-overflow-scrolling: touch;
    overflow-y: auto;
    border-radius: 6px;
    height: 100%;
    text-align: left;
    width: 496px;
}
`;

  const categoriesWrapper = `
.OpenCategoriesMenuController__container .CategoriesMenu .categoriesWrapper {
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    overflow-y: auto;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    height: auto;
    -webkit-justify-content: space-around;
    -ms-flex-pack: distribute;
    justify-content: space-around;
    margin: 0;
    padding: 30px 24px 16px;
}
`;

  const categoriesMenuList = `
.OpenCategoriesMenuController__container .CategoriesMenu ul {
    margin: 0;
    padding: 0;
    width: 201px;
}
`;

  const categoriesMenuListItem = `
.OpenCategoriesMenuController__container .CategoriesMenu .item:focus,
.OpenCategoriesMenuController__container .CategoriesMenu .item:hover {
  background-color: #ededed;
  background: -webkit-gradient(linear, left top, left bottom, from(#f1f1f1), to(#e8e8e8));
  background: -webkit-linear-gradient(#f1f1f1, #e8e8e8);
  background: linear-gradient(#f1f1f1, #e8e8e8);
  background: none;
  background-color: transparent;
  color: #cb2027;
}
.OpenCategoriesMenuController__container .CategoriesMenu .item:focus {
    outline: none;
}
.OpenCategoriesMenuController__container .CategoriesMenu .item {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    border-radius: 6px;
    color: #838383;
    display: inline-block;
    font-size: 14px;
    font-weight: 600;
    padding: 0;
    position: relative;
}
.OpenCategoriesMenuController__container .CategoriesMenu .categoriesWrapper ul li {
  margin-bottom: 3px;
}
`;

  const aboutLinks = `
.OpenCategoriesMenuController__container .AboutLinks {
    border-top: 1px solid #ebebeb;
    padding: 10px 15px;
}
.OpenCategoriesMenuController__container .AboutLinks li {
    display: -webkit-inline-box;
    display: -webkit-inline-flex;
    display: -ms-inline-flexbox;
    display: inline-flex;
    padding: 0 6px;
}
.OpenCategoriesMenuController__container .AboutLinks li a {
    color: #999;
    display: inline-block;
    padding: 0 !important;
}
.OpenCategoriesMenuController__container .AboutLinks ul {
    width: 100%;
}
.OpenCategoriesMenuController__container .AboutLinks li a.normalFont {
    font-size: 12px;
}
.OpenCategoriesMenuController__container .AboutLinks li a.smallFont,
.OpenCategoriesMenuController__container .AboutLinks li a.normalFont {
    color: #949494;
    font-weight: normal;
    text-shadow: 0 1px 1px rgba(255,255,255,0.8);
}
`;

  styles +=
    container +
    button +
    buttonEmphasis +
    buttonSpan +
    dropdown +
    categoriesMenu +
    categoriesWrapper +
    categoriesMenuList +
    categoriesMenuListItem +
    aboutLinks;

  return styles;
};

export default cssStyles;
